module.exports = __webpack_public_path__ + "img/send_gift-en.87544541.webp";